import { Component, NgZone, OnDestroy, OnInit } from "@angular/core";

import { AlertController, isPlatform, NavController, Platform } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { StorageService } from "./core/services/storage.service";
import { Network } from "@ionic-native/network/ngx";
import { ApiRequestService, AppData, ToastService } from "./shared";
import { Subscription } from "rxjs";
import { FcmMessagingService } from "./shared/services/fcm-messaging.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NoInternetComponent } from "./modules/modals/no-internet/no-internet.component";
import {
  APPSTORE_URL,
  FIREBASE_CONFIG_DEFAULT,
  FIREBASE_CONFIG_KEY,
  getConfig,
  NAV_ITEM,
  PLAYSTORE_URL,
  ROUTES_STR,
} from "./core/constants/app-constants";
import { environment } from "src/environments/environment";
import { AnalyticsService } from "./shared/services/analytics.service";
import { CLEVER_TAP_EVENT } from "./core/constants/clever-tab-event-constants";
import {
  appExitedObj,
  appInBackgroundEvent,
  appInForegroundEvent,
  appStartedCleverTabObj,
  onNotificationClickedEvent,
} from "./shared/utils/clever-tab-functions";
import { LottieSplashScreen } from "@ionic-native/lottie-splash-screen/ngx";
import { AppVersion } from "@ionic-native/app-version/ngx";
import { HttpResponse } from "@angular/common/http";
import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";

// import { FirebaseAnalytics } from "@awesome-cordova-plugins/firebase-analytics/ngx";
import { FirebaseDynamicLinks } from '@awesome-cordova-plugins/firebase-dynamic-links/ngx';
import { NavigationService } from "./shared/services/navigation.service";
import { LocalNotifications } from "@awesome-cordova-plugins/local-notifications/ngx";
import { WebIntentService } from "./shared/services/web-intent.service";
import { slideInAnimation } from "./core/route-animations/route-animation";
import { Facebook } from '@ionic-native/facebook/ngx';
import { FirebaseConfigService } from "./shared/services/firebase-config.service";
// import { Appsflyer } from "@awesome-cordova-plugins/appsflyer/ngx";
// import { AndroidNotch } from '@awesome-cordova-plugins/android-notch/ngx';
import { CacheService } from "./shared/services/cache.service";
import { VersionCheckService } from "./shared/services/version-check.service";
import { FirebaseService } from "./shared/services/firebase.service";
import MetaEventLogger from './shared/utils/metaEventLogger';
declare var cordova
declare var ZohoSalesIQ: any;
declare var window;
@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
  animations: [slideInAnimation]
})
export class AppComponent implements OnInit, OnDestroy {
  connectSubscription: Subscription;
  disconnectSubscription: Subscription;
  noInternetModal;
  currentVersion: string;
  forceUpdate: boolean;
  versionModal = 1;
  loggedDay = 1;
  paramSubscription: Subscription;
  deepLinkUrl = '';
  previousUrl: any = null;
  selectedIndex: number;
  timer: any;
  backgroundCalled: boolean;
  showBottomNavControllerCases = ['/home', '/account', '/explore', '/index.html']
  bottomNavList = NAV_ITEM;
  backNavInfo

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private lottieSplashScreen: LottieSplashScreen,
    private ngZone: NgZone,
    private router: Router,
    private storage: StorageService,
    private network: Network,
    private toast: ToastService,
    private fcmMessagingService: FcmMessagingService,
    private modalService: NgbModal,
    private analyticsService: AnalyticsService,
    private appVersion: AppVersion,
    private apiSerive: ApiRequestService,
    private alertController: AlertController,
    private iab: InAppBrowser,
    // private firebaseAnalytics: FirebaseAnalytics,
    private activatedRouter: ActivatedRoute,
    private firebaseDynamicLinks: FirebaseDynamicLinks,
    private navigationService: NavigationService,
    private localNotifications: LocalNotifications,
    private webIntentService: WebIntentService,
    private navCtrl: NavController,
    private fb: Facebook,
    private firebaseConfigService: FirebaseConfigService,
    // private appsFlyer: Appsflyer,
    // private androidNotch: AndroidNotch,
    // private androidNotch: AndroidNotch,
    private versionCheckService: VersionCheckService,
    private firebaseService: FirebaseService
  ) {
    console.log("appInit");
    AppData.backButtonInfo$.subscribe(data => {
      if (data && data.queryParams) {
        this.backNavInfo = {
          queryParams: data.queryParams,
        }
      } else {
        this.backNavInfo = null
      }
    })
    document.addEventListener(
      "backbutton",
      async (event) => {
        AppData.navigate = true;
        console.log(window.location.pathname)
        if (window.location.pathname === "/payments") {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        if (window.location.pathname === ROUTES_STR.orderConfirmation) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        let isRedirectPresent = false;
        if (await this.alertController.getTop()) {
          this.alertController.dismiss();
          return;
        }
        if (this.modalService.hasOpenModals()) {
          this.modalService.dismissAll();
          return;
        }
        this.paramSubscription = this.activatedRouter.queryParams.subscribe(
          (params) => {
            let queryString = {};
            if (window.location.pathname !== ROUTES_STR.noInternet) {
              if (params.hasOwnProperty("redirectUrl") && AppData.navigate) {
                isRedirectPresent = true;
                AppData.navigate = false;
                if (this.backNavInfo) {
                  queryString = this.backNavInfo.queryParams
                  this.navigate([params.redirectUrl], queryString)
                } else {
                  this.navigate([params.redirectUrl], {});
                }
              } else if (Object.keys(params).length > 0) {
                this.navigate([ROUTES_STR.home], {});
              }
            } else {
              navigator["app"].exitApp();
            }
          }
        );
        this.paramSubscription.unsubscribe();
        if (!isRedirectPresent) {
          switch (this.router.url) {
            case ROUTES_STR.home:
            case ROUTES_STR.welcome:
            case ROUTES_STR.noInternet:
              navigator["app"].exitApp();
              break;
            case ROUTES_STR.account:
            case ROUTES_STR.explore:
            case ROUTES_STR.cart:
              this.navigate([ROUTES_STR.home], {});
              break;
            case ROUTES_STR.orderHistory:
              this.navigate([ROUTES_STR.account], {});
              break;
            case ROUTES_STR.payments:
              this.navCtrl.pop();
              break;
            default:
              break;
          }
        }
      },
      false
    );

    // AppData.newUpdateReleased$.subscribe((data) => {
    //   if (data) {
    //     if (AppData.userLoginDay === "" || this.forceUpdate === true) {
    //       AppData.userLoginDaySub$.next("currentTime");
    //       const playStoreUrl = isPlatform("ios") ? APPSTORE_URL : PLAYSTORE_URL;
    //       //window.open(this.playStoreUrl, '_system');
    //       this.iab.create(playStoreUrl, "_system", { location: "yes" });
    //     }
    //   }
    // });
    // }


    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        console.log('URL::', e.url);
        if (!this.showBottomNavControllerCases.includes(e.url.split('?')[0])) {
          document.getElementById('add-remove-display').style.display = 'none'
        } else {
          document.getElementById('add-remove-display').style.display = 'block'

        }
        this.bottomNavList.forEach((obj, ind) => {
          if (obj.url === window.location.pathname) {
            this.selectedIndex = ind;
            AppData.bottomNavMobileIndSub$.next(this.selectedIndex);
          }
        })
      }
    });

    AppData.bottomNavMobileIndSub$.subscribe(ind => this.selectedIndex = ind);
    this.initializeApp();
  }
  ngOnInit() {
    AppData.bottomNavBarHideOnExplore$.subscribe((data) => {
      console.log(data)
      if (data === true) {
        document.getElementById('add-remove-display').style.display = 'none'
      } else if (data === false) {
        document.getElementById('add-remove-display').style.display = 'block'
      }
    })
    AppData.modalCloseAnimation$.subscribe(text => {
      let modal = this.modalService["_modalStack"]["_modalRefs"][0];
      let anmiationName = 'modal-close-bottom'
      if (text === 'center') {
        anmiationName = 'modal-close-center'
      } else if (text === 'center-menu') {
        anmiationName = 'modal-close-center-menu'
      }
      if (modal) {
        console.log(modal)
        const data = (modal as any)._windowCmptRef.instance.windowClass
        let instance = (modal as any)._windowCmptRef.instance;
        let fx = (modal as any)._removeModalElements.bind(modal);
        (modal as any)._removeModalElements = () => {
          modal._windowCmptRef.instance.windowClass = '';
          instance.windowClass = `${anmiationName} ${data}`;
          setTimeout(fx, 400);
        };
      }
    })
  }

  initializeApp() {
    this.platform.ready().then(async () => {
      let node = document.createElement("script");
      node.src = `https://maps.googleapis.com/maps/api/js?key=${environment.mapApiKey}&libraries=places&language=en`;
      node.type = "text/javascript";
      node.async = false;
      node.charset = "utf-8";
      document.getElementsByTagName("head")[0].appendChild(node);

      this.appVersion.getVersionCode().then((versionCode) => {
        console.log('version Code', versionCode);
        AppData.appVersionCodeSub$.next(versionCode.toString());
      });
      await this.setNavigation();
      this.checkNetworkConnection();
      // this.statusBar.overlaysWebView(true);
      // this.statusBar.backgroundColorByHexString("#FFFFFF");
      this.fcmMessagingService.tokenSubscribe();
      this.firebaseConfigService.fetchActivate();
      document.addEventListener("deviceready", () => {
        this.initFacebookSDK();
        // this.initAppsFlyer();
      });
      this.firebaseService.init();
      if (this.isFirstOpen()) {
        this.firebaseService.logCustomEvent("first_open", {
          app_name: 'yumzy-ios',
          timestamp: Number(Date.now()),
          client: 'iOS',
        });
      }
      // await this.appsFlyer.initSdk(
        // { devKey: "8fgba3qyvssLWYT3u6LvB5"},
      // );
      if (this.platform.is('android')) {
        // this.androidNotch.getInsetTop()
        // .then((px) => {
        // AppData.statusBarHeight = px;
        // AppData.statusBarHeight$.next(px);
        // console.log('Inset size: ', px)
        // })
        // .catch((error: any) => console.log('Error: ', error))

        // let initialHeight = document.documentElement.clientHeight;
        // window.addEventListener('resize', resizeFunction);
        // function resizeFunction() {
        //   alert('STATUS BAR HEIGHT' + (document.documentElement.clientHeight - initialHeight));
        //   AppData.statusBarHeight = document.documentElement.clientHeight - initialHeight;
        //   window.removeEventListener('resize', resizeFunction);
        // }
        this.statusBar.overlaysWebView(true);
        this.statusBar.styleDefault();
      }
      this.statusBar.overlaysWebView(true);
      this.statusBar.styleDefault();
      console.log("status barheight", this.statusBar);

      this.splashScreen.hide();
      this.lottieSplashScreen.hide();



      this.versionCheckService.versionAPI();

      //ZohoSalesIQ Initialization
      // Old Account Keys
      // const ZOHO_APP_KEY = 'XMz2%2FwuyoHBi%2FisUXANsdz1VLa%2F%2BCv9k_in';
      // const ZOHO_ANDROID_ACCESS_KEY = '6Cs6q7aHnPd72ZBZsldQQMacn6HfS4U92sxiAuWG%2FrKSO7BZeVySKbq8w4%2BwkWG22iEswMTH3tuooCO6WTvbAdGsDdGxiJwsvdDigj%2Bt4%2BmKg9kEqERjEQ5Y6f05A68hYgPpRKKE5iFJfVLiR91gPMtMyVqX6c6t';
      // const ZOHO_IOS_ACCESS_KEY = '6Cs6q7aHnPd72ZBZsldQQGGoWteph%2Bwx8zkK7FYBEsFuI%2FBlXcnZzZrlqEC3WiTsHBfS8zopFSv77BHhxUcVnvRZty6KtTlqNFuUecE9%2FZiL9wyAdj5vVA5Y6f05A68hYgPpRKKE5iFJfVLiR91gPMtMyVqX6c6t';

      // New Account Keys
      const ZOHO_APP_KEY = 'UXuMidQct2oG11r4LhWg0vpKqsHfPxErywgGZcvr9nx8wGfXIyZwXWmT93FTyJss_in';
      const ZOHO_ANDROID_ACCESS_KEY = '6Cs6q7aHnPd72ZBZsldQQMacn6HfS4U92sxiAuWG%2FrKSO7BZeVySKbq8w4%2BwkWG22iEswMTH3tuooCO6WTvbAdGsDdGxiJwsvdDigj%2Bt4%2BmKg9kEqERjEQ5Y6f05A68hYgPpRKKE5iFJfVLiR91gPMtMyVqX6c6t';
      const ZOHO_IOS_ACCESS_KEY = '6Cs6q7aHnPd72ZBZsldQQBHYWFeMhY4rrdtyCeWRYftsLQ76ZGpF7ilhtjZ%2BIWVcBh%2BuUwIR0hb4V6%2FG2RhPtAmb21y62s7KdtYW02dOf3Xreoj4bK7VTQ%3D%3D';

      if (this.platform.is('ios')) {
        ZohoSalesIQ.init(ZOHO_APP_KEY, ZOHO_IOS_ACCESS_KEY);
      } else if (this.platform.is('android')) {
        ZohoSalesIQ.init(ZOHO_APP_KEY, ZOHO_ANDROID_ACCESS_KEY);
      }

      console.log('event log ');
      this.firebaseDynamicLinks.getDynamicLink().then((data) => {
        console.log('dynamic link Success:: ', data)
        if (data) {
          this.processDeepLink(data.deepLink);
        }
      })

      // this.firebaseAnalytics.logEvent('page_view', { page: "HomePage" })
      // this.firebaseAnalytics
      //   .logEvent("page_view", { page: "dashboard" })
      //   .then((res: any) => console.log(res))
      //   .catch((error: any) => console.error(error));



      setTimeout(async () => {
        if (AppData.userId && AppData.currentAddressObj) {
          this.analyticsService.cleverTapEvent(
            CLEVER_TAP_EVENT.APP_STARTED,
            appStartedCleverTabObj(CLEVER_TAP_EVENT.APP_STARTED)
          );
        }
      }, 1000);
      this.firebaseDynamicLinks.onDynamicLink().subscribe(async (data) => {
        console.log('dynamic link clicked -> ', data);
        this.deepLinkUrl = await data.deepLink;
        this.processDeepLink(data.deepLink);
      }, (error) => { console.log(error) });
      //notification handling
      this.fcmMessagingService.onNotifications().subscribe((data) => {
        console.log('Notification data: ', data);
        console.log('on notification check');
        if (data.messageType === 'notification') {
          if (data.tap) {
            this.navigationService.processNavigation(data);
            this.analyticsService.cleverTapEvent(CLEVER_TAP_EVENT.PUSH_NOTIFICATION_CLICKED, onNotificationClickedEvent(data));
          } else {
            //if (data['gcm.message_id']) {
            console.log("notification scheduling");

            // TODO:: Use aps when ios else use above object

            // "cordova-plugin-local-notification-12" has not implemented in IOS,cordova-plugin-local-notification": "^0.9.0-beta.2" is not compatible with Android SDK-31 
            if (isPlatform("ios")) {
              this.localNotifications.schedule({
                // id: data["gcm.message_id"],
                title: data["aps"]["alert"]["title"],
                text: data["aps"]["alert"]["body"],
                data: { notification: data },
                foreground: true,
              });
            } else {
              const notificationOptions = {
                // id: 1,
                title: data["title"],
                text: data["body"],
                data: { notification: data },
                foreground: true,
                priority: 1,

              };
              cordova.plugins.notification.local.schedule(notificationOptions);
            }

            this.localNotifications.on("click").subscribe(async (data) => {
              console.log("notification clicked");
              setTimeout(() => {
                this.navigationService.processNavigation(data.data.notification);
              }, 500);
            });
            //}
          }
        }
      })
    });


    this.platform.pause.subscribe(async () => {
      // this.analyticsService.cleverTapEvent(
      //   CLEVER_TAP_EVENT.APP_EXITED,
      //   appExitedObj()
      // );
      const timeLimit = AppData.firebaseRemoteConfig.app_background_time
        ? AppData.firebaseRemoteConfig.app_background_time
        : FIREBASE_CONFIG_DEFAULT.app_background_time
      console.log('timeLimit: ', timeLimit);
      this.timer = setTimeout(() => {
        this.analyticsService.cleverTapEvent(CLEVER_TAP_EVENT.APP_BACKGROUND, appInBackgroundEvent());
        this.backgroundCalled = true;
      }, timeLimit)

      const params = {
        app_name: 'yumzy-ios',
        timestamp: Number(Date.now()),
        client: 'iOS',
        source: 'app-background',

        user_id: String(AppData.userId || "")
      };
      MetaEventLogger.appBackground(params);
      this.firebaseService.logCustomEvent('app_background', params);
    });

    this.platform.resume.subscribe(async () => {
      //alert('Pause event detected');
      console.log("app resume event");
      clearTimeout(this.timer);
      if (this.backgroundCalled) {
        this.analyticsService.cleverTapEvent(CLEVER_TAP_EVENT.APP_FOREGROUND, appInForegroundEvent());
        this.backgroundCalled = false;
      }
    });
  }

  private isFirstOpen(): boolean {
    const flag = localStorage.getItem("FIRST_OPEN_DONE");
    if (!flag) {
      localStorage.setItem("FIRST_OPEN_DONE", "true");
      return true;
    }
    return false;
  }

  private initFacebookSDK() {
    try {
      if (!window.facebookConnectPlugin) {
        console.warn("[App] FB plugin missing on device.");
        return;
      }

      // Mandatory for iOS 14+
      if (window.facebookConnectPlugin.setAdvertiserTrackingEnabled) {
        window.facebookConnectPlugin.setAdvertiserTrackingEnabled(true);
        console.log("[App] Advertiser tracking enabled.");
      }

      // Required for App Events activation
      this.fb.activateApp()
        .then(() => console.log("[App] FB activateApp() success"))
        .catch(err => console.error("[App] FB activateApp FAILED:", err));

    } catch (err) {
      console.error("[App] FB init EXCEPTION:", err);
    }
  }

  // convertOutletDeepLink(url) {
  //   try {
  //     const parsedUrl = new URL(url);

  //     // Split pathname: ["", "iQQI", "outletId_xxx"]
  //     const pathParts = parsedUrl.pathname.split('/').filter(Boolean);

  //     if (pathParts.length < 2) return url;

  //     const basePath = pathParts[0]; // iQQI
  //     const outletPart = pathParts[1]; // outletId_xxx

  //     if (!outletPart.startsWith('outletId_')) return url;

  //     const outletId = outletPart.replace('outletId_', '');

  //     return `${parsedUrl.origin}/${basePath}?outletId=${outletId}&destination=outlet`;
  //   } catch (e) {
  //     // fallback if invalid URL
  //     return url;
  //   }
  // }

  // initAppsFlyer() {
  //   let self = this;
  //   console.log("Initializing AppsFlyer SDK");
  //   window.plugins.appsFlyer.registerDeepLink(function(res) {  
  //     res = JSON.parse(res);
  //     // alert('AppsFlyer DDL ==> ' + res);  
  //     if(res.data && res.data.link) {
  //       console.log('AppsFlyer DDL Data Link ==> ' , res.data.link); 
  //       // self.processDeepLink(self.convertOutletDeepLink(res.data.link));
  //       self.processDeepLink(res.data.link);
  //     }
  //   }); 

  //   window.plugins.appsFlyer.registerOnAppOpenAttribution(function (res) {
  //     console.log("AppsFlyer registerOnAppOpenAttribution" , res);
  //     var deeplinkData = JSON.parse(res);
  //     if (deeplinkData.type === 'onAppOpenAttribution') {
  //       var link = deeplinkData.data.link;
  //       console.log(link);
  //       // redirect here     } else {  
  //       console.log('onAppOpenAttribution error');
  //     }
  //   }, function onAppOpenAttributionError(err) {
  //     console.log(err);
  //   });

  //   window.plugins.appsFlyer.initSdk({
  //     devKey: environment.APPSFLYER_DEV_KEY, // your AppsFlyer devKey  
  //     isDebug: true,
  //     appId: environment.APPLE_APP_ID, // your ios appID  
  //     waitForATTUserAuthorization: 10, //time for the sdk to wait before launch - IOS 14 ONLY!  
  //     onInstallConversionDataListener: true,
  //     onDeepLinkListener: true
  //   }, (result) => {
  //     console.log("Initialized AppsFlyer SDK", result);
  //     var conversionData = JSON.parse(result);

  //     if (conversionData.data.is_first_launch === true) {
  //       if (conversionData.data.af_status === 'Non-organic') {
  //         var media_source = conversionData.data.media_source;
  //         var campaign = conversionData.data.campaign;
  //         console.log('This is a Non-Organic install. Media source: ' + media_source + ' Campaign: ' + campaign);
  //       } else if (conversionData.data.af_status === 'Organic') {
  //         console.log('Organic Install');
  //       }
  //     } else if (conversionData.data.is_first_launch === false) {
  //       // Not first launch    }  
  //     }

  //     function onError(err) {
  //       console.log(err);
  //     }
  //   }, (error) => {
  //     console.warn("Initializing AppsFlyer SDK error", error);
  //   });
  // }

  processDeepLink(deepLink) {
    const deeplink = new URL(decodeURI(deepLink)).search;
    const urlParams = new URLSearchParams(deeplink);
    // console.log('appsFlyer deeplink params: ', JSON.stringify( urlParams) , JSON.stringify(deeplink ));
    if (urlParams.has("referralCode") && (AppData.isTemporary || !(AppData.userId || AppData.currentAddressObj))) {
      const referralCode = urlParams.get('referralCode')
      AppData.userReferralCodeSub$.next(referralCode);
      AppData.userReferralCode = referralCode;
      const queryParams = {}
      if (!(AppData.userId || AppData.currentAddressObj)) {
        queryParams['redirectUrl'] = "/welcome"
      } else {
        queryParams['redirectUrl'] = "/home"
      }
      this.navigate(['sign-up'], queryParams);
    } else {
      this.deepLinkUrl = deepLink;
      const deepLinkObj = JSON.parse('{"' + decodeURI(this.deepLinkUrl.split('?')[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
      console.log('deeplink data: ', deepLinkObj);
      this.navigationService.processNavigation(deepLinkObj);
      this.analyticsService.cleverTapEvent(CLEVER_TAP_EVENT.DEEP_LINK_CLICKED, onNotificationClickedEvent(deepLinkObj));
    }
  }

  checkNetworkConnection() {
    const type = this.network.type;
    let queryParams = {}
    this.disconnectSubscription = this.network.onDisconnect().subscribe(() => {
      if (this.router.url !== ROUTES_STR.noInternet) {
        this.previousUrl = window.location.pathname;
        let paramsQuery = window.location.search.substring(1);
        queryParams = decodeURI(paramsQuery)
          .split('&')
          .reduce((result, current) => {
            const [key, value] = current.split('=');
            result[key] = value;
            return result
          }, {})
        queryParams['navigateUrl'] = this.previousUrl;
        if (queryParams.hasOwnProperty("redirectUrl")) {
          queryParams['redirectUrl'] = decodeURIComponent(queryParams['redirectUrl']);
        }
      }
      this.toast.presentToast(`Connection error!`);
      this.ngZone.run(() => {
        this.router.navigate([ROUTES_STR.noInternet], { queryParams: queryParams });
      });
    });
  }

  async setNavigation() {
    console.log("called");
    const token = await this.storage.getItem("token");
    if (token !== null && token !== "" && token !== undefined) {
      if (this.router.url === "/welcome") {
        this.router.navigate(["/home"]);
      }
    } else {
      if(!(isPlatform('ios') || isPlatform('android'))){
        if(location.href.includes('outletId') || location.href.includes('outletid')){
          const url = new URL(location.href);
          const params = new URLSearchParams(url.search);

          const outletId = params.get("outletId") || params.get("outletid");
          const destination = params.get("destination");
          localStorage.setItem('outletId', outletId);
          localStorage.setItem('destination', destination);
        }
      }
      this.navigate(["/welcome"], {});
    }
  }

  public navigate(commands: any[], queryString): void {
    console.log(commands, queryString)
    this.ngZone
      .run(() => this.navCtrl.navigateBack(commands, { queryParams: queryString }))
      .then(() => {
        console.log("naviagation Success");
      });
    this.backNavInfo = null
  }


  ngOnDestroy() {
    this.analyticsService.cleverTapEvent(
      CLEVER_TAP_EVENT.APP_EXITED,
      appStartedCleverTabObj(CLEVER_TAP_EVENT.APP_STARTED)
    );
    this.connectSubscription.unsubscribe();
    this.disconnectSubscription.unsubscribe();
    document.removeEventListener("backbutton", () => { }, false);
  }
}
